module.exports = __webpack_public_path__ + "static/media/angle-right.fc973566.svg";